import {
  useTheme,
  variableToString
} from "@tamagui/core";
const useCurrentColor = (colorProp) => {
  const theme = useTheme();
  return variableToString(theme[colorProp] || colorProp || theme.color);
};
export {
  useCurrentColor
};
//# sourceMappingURL=useCurrentColor.js.map
